import Vue from "vue";
import VueRouter from "vue-router";
import auth from "@/router/auth";
import moment from "moment";

Vue.use(VueRouter);

function checkSession(to, from, next) {
  if (Vue.prototype.$session.exists()) {
    let timeOut = moment(Vue.prototype.$session.get("time-out"));
    let justNow = moment().format();
    if (moment(justNow).diff(moment(timeOut), "months") >= 1) {
      Vue.prototype.$session.destroy();
      next("/login");
    } else {
      next();
    }
  } else {
    next("/login");
  }
}

const routes = [
  {
    path: "*",
    redirect: {
      path: "/404",
    },
  },
  {
    path: "/404",
    name: "NotFound",
    component: () => import("../pages/errors/404.vue"),
  },
  {
    path: "/403",
    name: "AccessDenied",
    component: () => import(`@/pages/errors/403.vue`),
  },
  {
    path: "",
    name: "Login",
    component: () => import("../pages/Login.vue"),
    alias: "/login",
    beforeEnter(to, from, next) {
      if (Vue.prototype.$session.exists()) {
        next("/client/Search");
      } else {
        next();
      }
    },
  },
  {
    path: "/new-User",
    name: "NewUser",
    component: () => import("../pages/NewUser.vue"),
  },
  {
    path: "/auth/password",
    name: "authPassword",
    component: () => import("../pages/auth/password.vue"),
  },
  {
    path: "/auth/newPassword",
    name: "newPassword",
    props: (route) => ({ query: route.query.id }),
    component: () => import("../pages/auth/newPassword.vue"),
  },
  {
    path: "/auth/regulation",
    name: "regulation",
    component: () => import("../pages/auth/regulation.vue"),
    // beforeEnter: checkSession,
  },
  {
    path: "/",
    name: "Root",
    redirect: {
      name: "Login",
    },
    component: () => import(`../pages/client/Root.vue`),
    children: [
      {
        path: "/client/Search",
        name: "Search",
        component: () => import(`../pages/client/reservation/Search.vue`),
        beforeEnter: checkSession,
      },
      {
        path: "/client/Form/:name/:zone/:id",
        name: "Form",
        component: () => import(`../pages/client/reservation/Form.vue`),
        beforeEnter: checkSession,
      },
      {
        path: "/client/AnotherReserve/:name/:zone/:floor/:id",
        name: "AnotherReserve",
        component: () =>
          import(`../pages/client/reservation/AnotherReserve.vue`),
        beforeEnter: checkSession,
      },
      {
        path: "/client/User",
        name: "User",
        component: () => import(`../pages/client/profile/User.vue`),
        beforeEnter: checkSession,
      },
      {
        path: "/client/Historic",
        name: "Historic",
        component: () => import(`../pages/client/MyReservation/Historic.vue`),
        beforeEnter: checkSession,
      },
      {
        path: "/client/MyLocation",
        name: "MyLocation",
        component: () => import(`../pages/client/MyReservation/MyLocation.vue`),
        beforeEnter: checkSession,
      },
      {
        path: "/client/Survey/:id",
        name: "Survey",
        component: () => import(`../pages/client/MyReservation/Survey.vue`),
        beforeEnter: checkSession,
      },
      {
        path: "/client/ChangePassword",
        name: "changePassword",
        component: () => import("../pages/auth/newPassword.vue"),
        beforeEnter: checkSession,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
